import printJS from 'print-js'
import { PrintSize } from '@/models/Enums';
import { isElectron } from './electron';
import { getItem, setItem } from './localStorage';
import { api } from '@/services/Api';
import { Settings } from '@/models/Interfaces';

export async function printPdf(url: string): Promise<any> {
    let resolvePromise: any = null;
    let rejectPromise: any = null;
    const promise = new Promise((resolve, reject) => {
        resolvePromise = resolve;
        rejectPromise = reject;
    });
    printJS({ printable: url, type: 'pdf', onPrintDialogClose: () => resolvePromise(), onError: (error) => rejectPromise(error) });

    return promise;
}

const PRINTER_SETTINGS_KEY = 'printer';

export async function getPrinterSettings(): Promise<Settings | null> {
    if (isElectron()) {
        return await getFromElectron();
    }
    else {
        return getFromLocalStorage();
    }
}

export async function getOrInitPrinterSettings(): Promise<Settings | null> {
    if (isElectron()) {
        return await getFromElectron();
    }
    else {
        return await getOrInitFromLocalStorage();
    }
}

export async function getConnectedPrinters(): Promise<string[]> {
    if (isElectron()) {
        return await getPrintersFromElectron();
    }
    else {
        return [];
    }
}

export async function saveDefaultPrinterSettings() {
    await savePrinterSettings({
        receiptPrinterName: 'defalut',
        receiptPrinterSize: PrintSize.Check_8cm,
        ticketPrinterName: 'defalut',
        ticketPrinterSize: PrintSize.Check_8cm,
        shiftPrinterName: 'default',
        shiftPrinterSize: PrintSize.Check_8cm
    });
}

export async function savePrinterSettings(settings: Settings) {
    if (isElectron()) {
        await saveToElectron(settings);
    }
    else {
        saveToLocalStorage(settings);
    }
}

// ELECTRON

/**
 * Uses AppData through Electron to get saved {@link PrinterSettings}
 */
async function getFromElectron(): Promise<Settings | null> {
    const response = await api.getSettings();

    if (response.data) {
        return response.data;
    }

    return null;
}

async function getPrintersFromElectron(): Promise<string[]> {
    const response = await api.getPrinters();

    if (response.data) {
        return response.data
    }

    return [];
}

/**
 * Uses AppData through Electron to save {@link PrinterSettings} 
 */
async function saveToElectron(settings: Settings) {
    return await api.setSettings(settings);
}

// LOCAL STORAGE

/**
 * Uses browser {@link localStorage} to get saved {@link PrinterSettings}
 */
async function getOrInitFromLocalStorage(): Promise<Settings | null> {
    const settings = getFromLocalStorage();

    // REMOVE AFTER NEXT RELEASE
    if ((settings as any)?.receipt != undefined) {
        await saveDefaultPrinterSettings();
        return getFromLocalStorage();
    }

    if (settings) {
        return settings;
    }

    await saveDefaultPrinterSettings();

    return getFromLocalStorage();
}

/**
 * Uses browser {@link localStorage} to get saved {@link PrinterSettings}
 */
function getFromLocalStorage(): Settings | null {
    const json = getItem(PRINTER_SETTINGS_KEY);
    let settings: Settings | null = null;
    if (json) {
        settings = JSON.parse(json);
    }
    return settings;
}

/**
 * Uses browser {@link localStorage} to save {@link PrinterSettings}
 */
function saveToLocalStorage(settings: Settings) {
    setItem(PRINTER_SETTINGS_KEY, JSON.stringify(settings));
}